import { collectResourceDatasetNames, normalizeAppVersionListForView } from '../genericResourceManage/genericResourceInfoHelper'
import { ensureAiAssistantJsonConfig, normalizeAiAssistantDetail } from './aiAssistantAdapter'
import { getAppVersion } from './aiAssistantSaveHelper'

export { collectResourceDatasetNames, normalizeAppVersionListForView }

export function buildAiAssistantJsonSheetPayload(info) {
  const jsonConfig = info.jsonConfig || {}
  return {
    key: info.key,
    wallpaperName: info.wallpaperName || info.resourceName,
    wallpaperType: info.wallpaperType || info.assetType,
    jsonConfig,
  }
}

export function normalizeAiAssistantInfoDetail(raw) {
  const detail = normalizeAiAssistantDetail(raw)
  detail.jsonConfig = ensureAiAssistantJsonConfig(detail.jsonConfig)

  if (detail.androidNeglectVersion) {
    detail.androidNeglectVersion = Array.isArray(detail.androidNeglectVersion)
      ? detail.androidNeglectVersion.join(',')
      : detail.androidNeglectVersion
  }
  if (detail.iosNeglectVersion) {
    detail.iosNeglectVersion = Array.isArray(detail.iosNeglectVersion)
      ? detail.iosNeglectVersion.join(',')
      : detail.iosNeglectVersion
  }

  detail.wallpaperAppVersionList = normalizeAppVersionListForView(
    getAppVersion(detail.wallpaperAppVersionList)
  )

  if (!detail.countryList) {
    detail.countryList = { isExclude: true, countries: [] }
  }

  detail.thumbUrl = detail.thumbUrl || (detail.jsonConfig.aiRole && detail.jsonConfig.aiRole.avatar) || ''
  detail.resourceName = detail.resourceName || detail.wallpaperName || ''
  return detail
}

export function aiAssistantDisplayTitle(info) {
  return info.resourceName || info.wallpaperName || info.key || '—'
}

export function aiAssistantRoleName(info) {
  const role = (info.jsonConfig && info.jsonConfig.aiRole) || {}
  return role.name || info.roleName || '—'
}
